import { QueryClient } from '@tanstack/react-query';

function isAuthError(error: unknown): boolean {
  if (typeof error !== 'object' || error === null || !('code' in error)) return false;
  const code = Number((error as { code?: unknown }).code);
  return code === 401 || code === 403;
}

/**
 * Cliente de datos remotos. Un fallo de red se reintenta; la falta de permiso
 * no, porque el backend ya respondió y repetir la consulta no cambia nada.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        gcTime: 5 * 60_000,
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => !isAuthError(error) && failureCount < 2,
      },
      mutations: {
        retry: false,
      },
    },
  });
}
